module.exports = __webpack_public_path__ + "static/media/store_award.acfd0ed7.svg";